import CustomLink from "./CustomLink";
import { MapPin, Bus, Utensils, Landmark } from "lucide-react";

export default function QuickLinks() {
  const quickLinks = [
    {
      icon: <MapPin className="text-2xl md:text-3xl" />,
      title: "Destinations",
      href: "/destinations"
    },
    {
      icon: <Bus className="text-2xl md:text-3xl" />,
      title: "Transportation",
      href: "/transportation"
    },
    {
      icon: <Utensils className="text-2xl md:text-3xl" />,
      title: "Cuisine",
      href: "/cuisine"
    },
    {
      icon: <Landmark className="text-2xl md:text-3xl" />,
      title: "Culture",
      href: "/culture"
    }
  ];

  return (
    <section className="py-8 md:py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {quickLinks.map((link, index) => (
            <CustomLink key={index} href={link.href}>
              <div className="group flex flex-col items-center p-4 bg-[#F5F5F5] rounded-lg quick-link-hover transition duration-200 cursor-pointer">
                <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-[#E30A17] text-white mb-3 quick-link-icon transition duration-200">
                  {link.icon}
                </div>
                <span className="font-sans font-semibold text-center quick-link-text transition duration-200">
                  {link.title}
                </span>
              </div>
            </CustomLink>
          ))}
        </div>
      </div>
    </section>
  );
}
